import { FC, useMemo } from 'react'
import styles from 'components/features/future/FutureLayerPane/GetDivorced.styl'
import { LAYER_METAS } from 'constants/future'
import { FutureLayerUID, FutureLayer } from 'components/features/future/types'
import { FuturePanePreset } from 'components/features/future/FuturePanePreset/FuturePanePreset'
import * as yup from 'yup'
import { useLayerSelector, extendCommonSchema } from 'components/features/future/helpers'
import { FutureWhenInput } from 'components/features/future/FutureWhenInput/FutureWhenInput'
import { FutureFieldSlider } from 'components/features/future/FutureField/FutureFieldSlider'
import { maskCurrencyFromZero } from 'components/atoms/inputs/maskedInput'
import { schemaNumber } from 'schemas/baseSchema'
import { useCollectLayerErrors } from 'components/features/future/hooks/useCollectErrors'
import { ObjectSchema } from 'yup'
import { UpdateMaterialStatus } from 'components/features/future/FutureLayerPast/UpdateMaterialStatus/UpdateMaterialStatus'
import { LayerStatus } from 'components/features/future/LayerStatus/LayerStatus'

const LAYER_SLUG = 'get_divorced' as const
type LayerSlugType = typeof LAYER_SLUG
type LayerType = Extract<FutureLayer, { slug: LayerSlugType }>

const schemaCreator = extendCommonSchema<LayerSlugType>(yup.object({
  value: schemaNumber,
}) as ObjectSchema<LayerType>)

type FutureLayerPaneGetDivorcedProps = {
  uid?: FutureLayerUID
  onCancel: () => void
}

export const FutureLayerPaneGetDivorced: FC<FutureLayerPaneGetDivorcedProps> = (props) => {
  const { onCancel, uid } = props
  const layer = useLayerSelector<LayerSlugType>(props)
  const { icon, name } = LAYER_METAS[LAYER_SLUG]

  const layerWidthDefaults = useMemo(() => ({
    value: 15000,
    ...layer,
  } as typeof layer), [layer])

  return (
    <FuturePanePreset<LayerSlugType>
      layer={ layerWidthDefaults }
      slug={ LAYER_SLUG }
      name={ name }
      icon={ icon }
      type='event'
      schemaCreator={ schemaCreator }
      onCancel={ onCancel }
    >
      <FormFields uid={ uid } />
    </FuturePanePreset>
  )
}

type FormFieldsProps = {
  uid?: FutureLayerUID
}
const FormFields: FC<FormFieldsProps> = (props) => {
  const { uid } = props

  const errors = useCollectLayerErrors<LayerType>()

  const pastCardChild = useMemo(() => (
    <UpdateMaterialStatus />
  ), [])

  const completeChild = useMemo(() => (
    <h1>
      Event Completed
    </h1>
  ), [])

  return (
    <LayerStatus uid={ uid || null } pastContent={ pastCardChild } completeContent={ completeChild } type='event'>
      <FutureWhenInput error={ errors.whenField } />

      <FutureFieldSlider
        label='One-time costs'
        name='value'
        mask={ maskCurrencyFromZero }

        note='The average divorce costs $15,000.'
        error={ errors.value }

        min={ 0 }
        max={ 100000 }
        step={ 100 }
      />

      <p className={ styles.layerNote }>
        If you expect to pay alimony, consider also <br /> adding it as a New Expense.
      </p>

    </LayerStatus>
  )
}
